import { CircleAlert } from 'lucide-react';
import { type InputHTMLAttributes, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Input as InputBase } from '../Input';
import { FieldFeedback, FieldLabel } from './FieldLabel';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  explanation?: string;
  label: string;
  name: string;
}

export function Input(props: Props) {
  const [error, setError] = useState('');
  const { explanation, label, className, required, ...rest } = props;

  return (
    <label className={twMerge('block', 'group', className)}>
      <FieldLabel label={label} required={required} explanation={explanation} />
      <InputBase
        wrapperClassName="mt-1"
        required={required}
        onInvalid={(e) => {
          setError(e.currentTarget.validationMessage);
        }}
        {...rest}
      />
      {error && (
        <FieldFeedback className="mt-1 hidden group-has-[:user-invalid:not(:placeholder-shown)]:flex">
          <CircleAlert aria-hidden="true" />
          <span className="truncate">{error}</span>
        </FieldFeedback>
      )}
    </label>
  );
}
